var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { parse } from 'date-fns';
import { DataTableSource } from '../../../classes/DataTableSource/datatablesource';
import { ProgramInfo, StudentCollegeInfo, } from '../../../services/application/application.service';
import { DialogService } from '../../../services/dialogs/dialogs.service';
import { UserInfo } from '../../../services/user/user.service';
import { FormStatusPipe } from '../../../pipes/formstatus.pipe';
var StudentCollegeRecordsComponent = /** @class */ (function () {
    function StudentCollegeRecordsComponent(dialogService, formStatusPipe) {
        this.dialogService = dialogService;
        this.formStatusPipe = formStatusPipe;
        // Private
        this.AllColumns = ['Selection', 'CollegeName', 'DEProgram', 'Term', 'Counselor', 'Status', 'Actions'];
        // Outputs
        this.add = new EventEmitter();
        this.cancel = new EventEmitter();
        this.change = new EventEmitter();
        this.programChange = new EventEmitter();
        this.remove = new EventEmitter();
        this.select = new EventEmitter();
        this.toggleAgreements = new EventEmitter();
        this.update = new EventEmitter();
        this.updateprogram = new EventEmitter();
    }
    StudentCollegeRecordsComponent.prototype.ngOnDestroy = function () { };
    StudentCollegeRecordsComponent.prototype.ngOnInit = function () { };
    StudentCollegeRecordsComponent.prototype.ngOnChanges = function () {
        if (this.StudentCollegeRecords) {
            this.StudentCollegeRecs = JSON.parse(JSON.stringify(this.StudentCollegeRecords));
            this.StudentCollegeRecs.forEach(function (item) {
                item.Edited = false;
                item.OriginalCounselorSAPID = item.CounselorSAPID;
            });
        }
        if (!this.SCRecordDataSource) {
            this.SCRecordDataSource = new DataTableSource(this.StudentCollegeRecs);
        }
        else {
            this.SCRecordDataSource.Update(this.StudentCollegeRecs);
        }
        if (this.User) {
            this.AsAdvisor = this.User.IsAdvisor;
            this.AsCollegeAdmin = this.User.IsCollegeAdmin;
            this.AsCollegeSupport = this.User.IsCollegeSupport;
            this.AsCounselor = this.User.IsCounselor;
            this.AsDeveloper = this.User.IsDeveloper;
            this.AsDistrictAdmin = this.User.IsDistrictAdmin;
            this.AsParent = this.User.IsParent;
            this.AsStudent = this.User.IsStudent;
        }
        // Set up headers for display
        this.VisibleHeaders = [];
        if (this.SmallDisplay) {
            this.VisibleHeaders.push('SmallDisplay');
        }
        else {
            if (this.StudentCollegeRecs && this.StudentCollegeRecs.length > 1) {
                this.VisibleHeaders.push('Selection');
            }
            this.VisibleHeaders.push('CollegeName');
            if (!this.AsParent) {
                this.VisibleHeaders.push('DEProgram');
            }
            this.VisibleHeaders.push('Term', 'Counselor', 'Status');
            if (this.SelectedCollege &&
                this.SelectedCollege.HistoricalRecord !== true &&
                !this.AsAdvisor &&
                !this.AsCollegeAdmin &&
                !this.AsCollegeSupport) {
                this.VisibleHeaders.push('Actions');
            }
        }
        this.NoData = !this.StudentCollegeRecs || !this.StudentCollegeRecs.length;
        this.ShownColumns = this.NoData ? ['NoData'] : this.SmallDisplay ? ['SmallDisplay'] : this.VisibleHeaders.slice();
    };
    // #region Add Student College Method
    StudentCollegeRecordsComponent.prototype.AddStudentCollege = function (col) {
        if (!col) {
            return;
        }
        this.add.emit(col);
    };
    // #endregion
    // #region Remove College Choice Method
    StudentCollegeRecordsComponent.prototype.RemoveCollegeChoice = function (col) {
        if (!col) {
            return;
        }
        // Emit the event
        this.remove.emit(col);
    };
    // #endregion
    // #region College Change Handler Method
    StudentCollegeRecordsComponent.prototype.CollegeChangeHandler = function (col) {
        if (!col) {
            return;
        }
        // Emit the event
        this.change.emit(col);
    };
    // #endregion
    // #region Cancel College Choice Method
    StudentCollegeRecordsComponent.prototype.CancelCollegeChoice = function (col) {
        if (!col) {
            return;
        }
        // Emit the event
        this.cancel.emit(col);
    };
    // #endregion
    // #region Cancel Dual Enrollment Program Change Handler Method
    StudentCollegeRecordsComponent.prototype.CancelDualEnrollmentProgramChangeHandler = function (col) {
        col.DualEnrollmentProgramID = col.OriginalDualEnrollmentProgramID;
        col.AcceleratedDegreeProgramID = col.OriginalAcceleratedDegreeProgramID;
    };
    // #endregion
    // #region Cancel Update Counselor Method
    StudentCollegeRecordsComponent.prototype.CancelUpdateCounselor = function (col) {
        col.CounselorSAPID = col.OriginalCounselorSAPID;
    };
    // #endregion
    // #region Dual Enrollment Program Change Handler Method
    StudentCollegeRecordsComponent.prototype.DualEnrollmentProgramChangeHandler = function (col) {
        if (!col) {
            return;
        }
        // Package up the new choice
        var packet = {
            DualEnrollStudentID: col.DualEnrollStudentID,
            ProgramID: col.DualEnrollmentProgramID,
            AcceleratedDegreeProgramID: col.AcceleratedDegreeProgramID,
            OriginalProgramID: col.OriginalDualEnrollmentProgramID,
            OriginalAcceleratedDegreeProgramID: col.OriginalAcceleratedDegreeProgramID,
        };
        // Emit the event
        this.updateprogram.emit(packet);
    };
    // #endregion
    // #region Program Option Change
    StudentCollegeRecordsComponent.prototype.ProgramOptionChange = function (event) {
        this.programChange.emit(event);
    };
    // #endregion
    // #region Select College Record Method
    StudentCollegeRecordsComponent.prototype.SelectCollegeRecord = function (col) {
        if (!col || col === this.SelectedCollege) {
            return;
        }
        // Emit the event
        this.select.emit(col);
    };
    // #endregion
    // #region Show Status Explanation Method
    StudentCollegeRecordsComponent.prototype.ShowStatusExplanation = function (status) {
        var self = this;
        var explain = self.formStatusPipe.transform(status, true);
        // Pop up the dialog
        self.dialogService
            .OpenMessageBoxDialog({
            TitleText: 'Information',
            MessageText: explain,
            OKText: 'OK',
        })
            .subscribe(function (result) { });
    };
    // #endregion
    // #region Toggle Agreements Method
    StudentCollegeRecordsComponent.prototype.ToggleAgreements = function (col) {
        this.toggleAgreements.emit(col);
    };
    // #endregion
    // #region Update College Method
    StudentCollegeRecordsComponent.prototype.UpdateCollege = function (col) {
        // Check for changes
        var changed = false;
        if (col.CounselorSAPID !== col.OriginalCounselorSAPID) {
            changed = true;
        }
        col.Edited = changed;
        this.update.emit(col);
    };
    return StudentCollegeRecordsComponent;
}());
export { StudentCollegeRecordsComponent };
// #region Custom Classes
// #region Student College Info UI Class
var StudentCollegeInfoUI = /** @class */ (function (_super) {
    __extends(StudentCollegeInfoUI, _super);
    function StudentCollegeInfoUI(info) {
        var _this = _super.call(this) || this;
        _this.DualEnrollStudentID = info.DualEnrollStudentID;
        _this.StudentID = info.StudentID;
        _this.SchoolYear = info.SchoolYear;
        _this.Term = JSON.parse(JSON.stringify(info.Term));
        _this.DateUpdated = info.DateUpdated ? parse(info.DateUpdated) : null;
        _this.CollegeID = info.CollegeID;
        _this.CollegeName = info.CollegeName;
        _this.CollegeSchoolYear = info.CollegeSchoolYear;
        _this.FormStatus = info.FormStatus;
        _this.DualEnrollmentProgramID = info.DualEnrollmentProgramID;
        _this.DualEnrollmentProgram = JSON.parse(JSON.stringify(info.DualEnrollmentProgram));
        _this.AcceleratedDegreeProgramID = info.AcceleratedDegreeProgramID;
        _this.OriginalDualEnrollmentProgramID = info.DualEnrollmentProgramID;
        _this.OriginalAcceleratedDegreeProgramID = info.AcceleratedDegreeProgramID;
        _this.CounselorSAPID = info.CounselorSAPID;
        _this.OriginalCounselorSAPID = info.OriginalCounselorSAPID;
        _this.CounselorApproved = info.CounselorApproved;
        _this.CounselorApprovedUser = info.CounselorApprovedUser;
        _this.CounselorApprovedDate = info.CounselorApprovedDate ? parse(info.CounselorApprovedDate) : null;
        _this.SchoolApproved = info.SchoolApproved;
        _this.SchoolApprovedUser = info.SchoolApprovedUser;
        _this.SchoolApprovedDate = info.SchoolApprovedDate ? parse(info.SchoolApprovedDate) : null;
        _this.CollegeApproved = info.CollegeApproved;
        _this.CollegeApprovedUser = info.CollegeApprovedUser;
        _this.CollegeApprovedDate = info.CollegeApprovedDate ? parse(info.CollegeApprovedDate) : null;
        _this.ParentHasApproved = info.ParentHasApproved;
        _this.ParentApprovedUser = info.ParentApprovedUser;
        _this.ParentApprovedDate = info.ParentApprovedDate ? parse(info.ParentApprovedDate) : null;
        _this.AsProxy = info.AsProxy;
        _this.ProxyParentName = info.ProxyParentName;
        _this.ProxyRelationship = info.ProxyRelationship;
        _this.ProxyDescription = info.ProxyDescription;
        _this.StudentCollegeAgreementApproved = info.StudentCollegeAgreementApproved;
        _this.StudentPolkAgreementApproved = info.StudentPolkAgreementApproved;
        _this.StudentCollegeID = info.StudentCollegeID;
        _this.AgreementText = info.AgreementText;
        _this.AgreementTextDate = info.AgreementTextDate ? parse(info.AgreementTextDate) : null;
        _this.AgreementConsentText = info.AgreementConsentText;
        _this.AvailableTerms = JSON.parse(JSON.stringify(info.AvailableTerms));
        _this.HistoricalRecord = info.HistoricalRecord;
        _this.FastTrackAdvised = info.FastTrackAdvised;
        _this.Edited = false;
        return _this;
    }
    return StudentCollegeInfoUI;
}(StudentCollegeInfo));
export { StudentCollegeInfoUI };
// #endregion
// #region Student Program Change Info Class
var StudentProgramChange = /** @class */ (function (_super) {
    __extends(StudentProgramChange, _super);
    function StudentProgramChange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StudentProgramChange;
}(ProgramInfo));
export { StudentProgramChange };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/app/ui/studentcollegerecords/studentcollegerecords.component.ts.pre-build-optimizer.js